import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    state: {
        chat: {
            counteredList: [],
            isChatLoad: false,
            actualOpened: null,
            allNotReadCounter: 0
        },
        notifications: {
            list: [],
            newCount: -1
        }
    },
    mutations: {
        closeChat(state){
            state.chat.actualOpened = null;
        },
        initChat(state, list){

            state.chat.counteredList = list;
            let counter = 0;
            state.chat.counteredList.map((value)=>{
                counter += parseInt(value.noReadCount);
            });
            Vue.set(state.chat, 'allNotReadCounter', counter);

        },
        changeChatLoadStatus(state,status){
            Vue.set(state.chat, 'isChatLoad', status);
        },
        openChat(state, id){
            Vue.set(state.chat, 'isChatLoad', true);
            Vue.set(state.chat, 'actualOpened', id);

            state.chat.counteredList.map((value)=>{
                if(value.id === id){
                    Vue.set(value, 'isActive', true);
                    Vue.set(value, 'noReadCount', 0);
                    Chat.openChat(id,()=>{
                        $('#chat-user-name').text(value.firstname + " " + value.lastname);
                    });
                    Vue.set(state.chat, 'isChatLoad', false);
                    let counter = 0;
                    state.chat.counteredList.map((value)=>{
                        counter+=parseInt(value.noReadCount);
                    });
                    Vue.set(state.chat, 'allNotReadCounter', counter);
                }else{
                    value.isActive = false;
                }
            });
        },
        addNewMessage: (state, message) => {
            message = JSON.parse(message.data);

            if(!$('#chat-modal').hasClass('modal-show')){
                Chat.playSound();
                notify.createNotifier("Nowa wiadomość od: "+message.user.firstname,"info",4000);
                // push.create("Nowa wiadomość od: "+message.user.firstname, {
                //     body: "Nowa wiadomość od: "+message.user.firstname,
                //     timeout: 4000,
                //     vibrate: [200, 100],
                //     onClick: function () {
                //         window.focus();
                //         this.close();
                //     }
                // });
            }

            let fromId = message.user.id === window.AuthMiddleware.user.id ? message.msg.user_to : message.user.id;

            if(message.user.id !== window.AuthMiddleware.user.id){

                if($('#chat-modal').hasClass('modal-show') && Chat.isChatActive(fromId)){
                    Chat.addMessageToChat(message,()=>{
                        Chat.renderMessage();
                    });
                }else{
                    state.chat.counteredList.map((value)=>{
                        if(value.id === message.user.id){
                            Vue.set(value, 'noReadCount', 1+parseInt(value.noReadCount));
                        }
                    });
                }

                if(!$('#chat-modal').hasClass('modal-show')){
                    let counter = 0;
                    state.chat.counteredList.map((value)=>{
                        counter+=parseInt(value.noReadCount);
                    });
                    Vue.set(state.chat, 'allNotReadCounter', counter);
                }

            }else{
                Chat.actualChatMessage.push(message.msg);
                Chat.renderMessage();
            }

        },
        setNew: (state, notifications) => {
            if (notifications.length > state.notifications.list.length && state.notifications.newCount >= 0) {
                // push.create(notifications[0].title, {
                //     body: notifications.description,
                //     timeout: 4000,
                //     vibrate: [200, 100],
                //     onClick: function () {
                //         window.focus();
                //         this.close();
                //     }
                // });
                Notification.playSound();
            }
            state.notifications.list = notifications;
            state.notifications.newCount = notifications.length;
        },
        remove: (state, id) => {
            state.notifications.newCount--;
            state.notifications.list = state.notifications.list.filter(element => id != element.id);
        }
    },
    actions: {
        async asyncGetNotifications({state, commit}) {
            if (window.AuthMiddleware.user) commit('setNew', await window.Notification.getLast());
            window.Notification.checkInterval = setInterval(async () => {
                if (window.AuthMiddleware.user)
                    commit('setNew', await window.Notification.getLast());
            }, 5000);
        },
        async setAsRead({state, commit}, id) {
            await window.Notification.setAsRead(id);
            commit('remove', id);
        },
        closeChat({state, commit}){
            commit('closeChat');
        },openChat({state, commit}, id){
            commit('openChat', id);
        },
        async initChatSocket({state, commit}) {
            let canInitialize = window.Chat.init();
            if(canInitialize){
                commit("initChat", await window.Chat.getChatCounterList());
                window.Chat.chatWebSocket.onmessage = (e) => {
                    commit('addNewMessage', e);
                };
            }
        }
    }
});
